import { Observable } from "rxjs";

import * as http from "../../../services/http.service";
import { SearchResults } from "../../../types/search/search-results.interface";

import {
  FetchCommentsQuery,
  PostCommentForm,
} from "../types/comments-queries/comments-queries.interface";
import {
  mapFetchParams,
  mapPostParams,
} from "../types/comments-queries/comments-queries.functions";
import { objectToQueryString } from "../../../utils/helpers";
import { IComment } from "../types/icomment.interface";
import { map } from "rxjs/operators";

export function fetchComments(filters: FetchCommentsQuery): Observable<SearchResults<IComment>> {
  const params = mapFetchParams(filters);
  return http.get("/comments/", { params });
}

export function orderComments(searchResults: SearchResults<IComment>) {
  return {
    ...searchResults,
    results: searchResults.results.sort(
      (a: any, b: any) => Date.parse(a.posted) - Date.parse(b.posted)
    ),
  };
}

export function postComment(
  form: PostCommentForm,
  comments: SearchResults<IComment>
): Observable<SearchResults<IComment>> {
  const payload = mapPostParams(form);
  const { content, ...params } = payload;
  const urlQuery = objectToQueryString(params);

  return http
    .post<IComment>(`/comments/create/?${urlQuery}`, payload)
    .pipe(map(addCommentToResults(comments)));
}

const addCommentToResults = (comments: SearchResults<IComment>) => (
  comment: IComment
): SearchResults<IComment> => ({
  ...comments,
  results: comments.results.concat([comment]),
  count: comments.count + 1,
});
